<template>
    <div>
        <el-form
                ref="profile"
                size="mini"
                :model="model.profile"
                :rules="$options.rulesProfile"
                label-width="0"
                hide-required-asterisk
                :show-message="false">
            <div class="micro-head-row">
                <span>&nbsp;</span>
                <span>Amount</span>
                <span>Type</span>
                <span>Start</span>
                <span>End</span>
            </div>
            <div class="micro-form-row">
                <span>Profile slope</span>
                <el-form-item class="form-item" prop="slope">
                    <el-input v-model="model.profile.slope" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item">
                    <el-input :placeholder="$handlers.gear.MICRO_TYPE_LABEL.LINEAR" disabled/>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitLower">
                    <el-input v-model="model.profile.evalLimitLower" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitUpper">
                    <el-input v-model="model.profile.evalLimitUpper" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
            </div>
            <div class="micro-form-row">
                <span>Profile crown</span>
                <el-form-item class="form-item" prop="crown">
                    <el-input v-model="model.profile.crown" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item">
                    <el-input :placeholder="$handlers.gear.MICRO_TYPE_LABEL.PARABOLIC" disabled/>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitLower">
                    <el-input v-model="model.profile.evalLimitLower" disabled>
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitUpper">
                    <el-input v-model="model.profile.evalLimitUpper" disabled>
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
            </div>
            <div class="micro-form-row">
                <span>Root relief</span>
                <el-form-item class="form-item" prop="rootRelief">
                    <el-input v-model="model.profile.rootRelief" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="rootReliefType">
                    <el-select v-model="model.profile.rootReliefType" @change="changeMicro">
                        <el-option
                                v-for="item in $options.reliefTypes"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-item" prop="rootReliefStart">
                    <el-input v-model="model.profile.rootReliefStart" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <span>&nbsp;</span>
            </div>
            <div class="micro-form-row">
                <span>Tip relief</span>
                <el-form-item class="form-item" prop="tipRelief">
                    <el-input v-model="model.profile.tipRelief" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="tipReliefType">
                    <el-select v-model="model.profile.tipReliefType" @change="changeMicro">
                        <el-option
                                v-for="item in $options.reliefTypes"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-item"
                              prop="tipReliefStart">
                    <el-input v-model="model.profile.tipReliefStart" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <span>&nbsp;</span>
            </div>
        </el-form>
        <hr>
        <el-form
                ref="lead"
                size="mini"
                :model="model.lead"
                :rules="$options.rulesLead"
                label-width="0"
                hide-required-asterisk
                :show-message="false">
            <div class="micro-head-row">
                <span>&nbsp;</span>
                <span>Amount</span>
                <span>Type</span>
                <span>Start</span>
                <span>End</span>
            </div>
            <div class="micro-form-row">
                <span>Lead slope</span>
                <el-form-item class="form-item" prop="slope">
                    <el-input v-model="model.lead.slope" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item">
                    <el-input :placeholder="$handlers.gear.MICRO_TYPE_LABEL.LINEAR" disabled/>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitLower">
                    <el-input v-model="model.lead.evalLimitLower" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitUpper">
                    <el-input v-model="model.lead.evalLimitUpper" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
            </div>
            <div class="micro-form-row">
                <span>Lead crown</span>
                <el-form-item class="form-item" prop="crown">
                    <el-input v-model="model.lead.crown" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item">
                    <el-input :placeholder="$handlers.gear.MICRO_TYPE_LABEL.PARABOLIC" disabled/>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitLower">
                    <el-input v-model="model.lead.evalLimitLower" disabled>
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="evalLimitUpper">
                    <el-input v-model="model.lead.evalLimitUpper" disabled>
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
            </div>
            <div class="micro-form-row">
                <span>Bottom relief</span>
                <el-form-item class="form-item" prop="rootRelief">
                    <el-input v-model="model.lead.bottomRelief" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="bottomReliefType">
                    <el-select v-model="model.lead.bottomReliefType" @change="changeMicro">
                        <el-option
                                v-for="item in $options.reliefTypes"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-item" prop="bottomReliefStart">
                    <el-input v-model="model.lead.bottomReliefStart" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <span>&nbsp;</span>
            </div>
            <div class="micro-form-row">
                <span>Top relief</span>
                <el-form-item class="form-item" prop="topRelief">
                    <el-input v-model="model.lead.topRelief" @change="changeMicro">
                        <template slot="suffix">{{ $options.unitLengthSmall }}</template>
                    </el-input>
                </el-form-item>
                <el-form-item class="form-item" prop="topReliefType">
                    <el-select v-model="model.lead.topReliefType" @change="changeMicro">
                        <el-option
                                v-for="item in $options.reliefTypes"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="form-item" prop="topReliefStart">
                    <el-input v-model="model.lead.topReliefStart" @change="changeMicro">
                        <template slot="suffix">%</template>
                    </el-input>
                </el-form-item>
                <span>&nbsp;</span>
            </div>
        </el-form>
    </div>
</template>

<script>
  import {rules} from "../../assets/js/validators";
  import requests from "../../requests";
  import handlers from "../../handlers";
  import {UNITS} from "../../handlers/modules/units";

  export default {
    name: "FormMicroDesign",
    props: {
      model: Object,
    },

    reliefTypes: [{
      label: handlers.gear.MICRO_TYPE_LABEL.LINEAR,
      value: requests.gear.MicroType.LINEAR,
    }, {
      label: handlers.gear.MICRO_TYPE_LABEL.PARABOLIC,
      value: requests.gear.MicroType.PARABOLIC,
    }],
    unitLengthSmall: UNITS.lengthSmall,
    rulesProfile: {
      slope: rules.requiredNumber,
      crown: rules.requiredNumber,
      evalLimitLower: rules.requiredNumber0To100,
      evalLimitUpper: rules.requiredNumber0To100,
      rootRelief: rules.requiredZeroPositiveNumber,
      rootReliefStart: rules.requiredNumber0To100,
      tipRelief: rules.requiredZeroPositiveNumber,
      tipReliefStart: rules.requiredNumber0To100,
    },
    rulesLead: {
      slope: rules.requiredNumber,
      crown: rules.requiredNumber,
      evalLimitLower: rules.requiredNumber0To100,
      evalLimitUpper: rules.requiredNumber0To100,
      bottomRelief: rules.requiredZeroPositiveNumber,
      bottomReliefStart: rules.requiredNumber0To100,
      topRelief: rules.requiredZeroPositiveNumber,
      topReliefStart: rules.requiredNumber0To100,
    },

    methods: {
      changeMicro() {
        // Emit change event to indicate microgeometry has changed.

        this.$emit('change');
      },

      // FORM VALIDATION
      async validateProfile() {
        let valid = true;
        try {
          await this.$refs.profile.validate();
        } catch (e) {
          valid = false;
          this.$message({
            type: 'error',
            message: 'Invalid profile modifications',
            center: true,
          });
        }

        return valid;
      },
      async validateLead() {
        let valid = true;
        try {
          await this.$refs.lead.validate();
        } catch (e) {
          valid = false;
          this.$message({
            type: 'error',
            message: 'Invalid lead modifications',
            center: true,
          });
        }

        return valid;
      },
      async validate() {
        const validProfile = await this.validateProfile();
        const validLead = await this.validateLead();
        return validProfile && validLead;
      },

      // FORM RESET
      resetFields() {
        this.$refs.profile.resetFields();
        this.$refs.lead.resetFields();
      }
    },
  }
</script>

<style scoped src="../../assets/css/form.css"/>
<style scoped lang="scss">
    .micro-form-row, .micro-head-row {
        display: grid;
        grid-template-columns: 85px repeat(4, 1fr);
        grid-gap: .25rem;
    }
    .micro-form-row > span:first-child {
        justify-self: right;
        align-self: center;
        font-size: var(--font-med);
        margin-right: .25rem;
    }
    .micro-head-row {
        justify-items: center;
        font-size: var(--font-med-small);
        margin-bottom: .25rem;
    }
</style>
